import React, { useCallback } from 'react';
import Input from 'shared/components/input/Input';
import Select from 'shared/components/select/Select';
import { formatAmount } from 'components/campaigns/helpers/helpers';
import {
  DropdownListType,
  ExcludesDropdownLists,
} from '../../CampaignConstants';
import useStore from '../../hooks/useCampaignStore';

function ExcludeAvailsFields({
  availsExcludes,
  setAvailsExcludes,
  setIsFormTouched,
}) {
  const { isCampaignActive } = useStore((state) => state);

  // Input Handling
  const handleExcludeSelection = useCallback(
    (id, data) => {
      setIsFormTouched(true);

      setAvailsExcludes((prev) =>
        prev.map((row) => {
          if (row.id === id) {
            return {
              ...row,
              value: '', // Reset value when dropdown changes
              selectedExclude: data.id,
            };
          }
          return row;
        })
      );
    },
    [availsExcludes, setIsFormTouched]
  );

  // TODO: We should create a reusable function in the future to sanitize inputs
  const sanitizeExcludeInputs = (valueToSanitize) => {
    let value = valueToSanitize; // value to return

    // Remove any non-digit characters
    value = value.replace(/[^0-9.]/g, '');

    // Remove preceding zeroes followed by integers but not decimal points
    if (value.match(/^0\d(?!\.)/)) {
      value = value.replace(/^0+/, '');
    }

    // Replace multiple zeroes with a single zero
    if (value.match(/^00+/)) {
      value = value.replace(/^00+/, '0');
    }

    // Ensure only one decimal point
    let parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
      parts = value.split('.');
    }

    // Limit to 9 digits before decimal and 2 after
    if (parts.length === 2) {
      const beforeDecimal = parts[0] !== '' ? parts[0].slice(0, 9) : '0';
      const afterDecimal = parts[1].slice(0, 2);
      value = beforeDecimal + '.' + afterDecimal;
    } else {
      value = value.slice(0, 9);
    }

    return value;
  };

  const handleOnExcludeInputChange = (id, e, selectedExclude) => {
    const excludesToSanitize = [
      DropdownListType.GREATER_THAN,
      DropdownListType.LESS_THAN,
    ];
    let value = e.target.value;

    setIsFormTouched(true);

    if (excludesToSanitize.includes(selectedExclude)) {
      value = sanitizeExcludeInputs(value);
    }

    setAvailsExcludes((prevState) =>
      prevState.map((row) => {
        if (row.id === id) {
          return {
            ...row,
            value,
          };
        }
        return row;
      })
    );
  };

  return (
    <>
      <div className="d-flex flex-column gap-10">
        {/* Section Title */}
        <div className="w-100 border-bottom d-flex">
          <span>Exclude avails</span>
        </div>
      </div>

      <div className="w-100 exclude-avail-fields">
        {availsExcludes.map((exclude, index) => {
          const CurrentExcludeDropdownList = Object.values(
            ExcludesDropdownLists
          )[index];

          // Check if the selected exclude is the first index
          const isFirstIndex =
            CurrentExcludeDropdownList.findIndex(
              (item) => item.id === exclude.selectedExclude
            ) === 0;

          return (
            <div className="excludes-rows">
              <div style={{ width: '100%', minWidth: '100px'  }}>
                <Select
                  text={
                    CurrentExcludeDropdownList.find(
                      (item) => item.id === exclude.selectedExclude
                    )?.name || CurrentExcludeDropdownList[0]?.name
                  }
                  list={CurrentExcludeDropdownList}
                  noSearch
                  onSelect={(e) => handleExcludeSelection(exclude.id, e)}
                  width={'100%'}
                  disabled={!isCampaignActive}
                />
              </div>
              <Input
                value={
                  isFirstIndex ? formatAmount(exclude.value) : exclude.value
                }
                maxLength={!isFirstIndex && 5}
                type={!isFirstIndex && 'decimal'}
                onChange={(e) =>
                  handleOnExcludeInputChange(
                    exclude.id,
                    e,
                    exclude.selectedExclude
                  )
                }
                style={{ width: '100%', maxWidth: '120px', color: '#212529' }}
                disabled={!isCampaignActive}
              />
            </div>
          );
        })}
      </div>
    </>
  );
}

export default ExcludeAvailsFields;
